import React from "react";
import {
  Box,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

const CROMBO_ORANGE = "#E16A2E";

const SummaryTable = ({
  item,
  itemCounter,
  priceArray,
  showAdvanced,
  productTotal,
  productPriceAverage,
  productDiscountAverage,
  totalDisplayForCount,
  extraDisplay,
  extraItemTotal,
  extraPriceAverage,
  extraDiscountAverage,
  delivery,
  bonusDiscountFunc,
  grandTotal,
  t,
}) => {
  return (
    <Box className='bg-white p-4 rounded-md border border-gray-200'>
      <Typography variant='subtitle1' className='font-semibold mb-2'>
        {t("admin:finalSummary") || "Final Summary"}
      </Typography>
      <Divider />

      {/* MAIN PRODUCT TABLE */}
      <Box mt={2}>
        <Typography variant='subtitle2' gutterBottom>
          Main Product
        </Typography>
        <TableContainer>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell align='right' sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                  Price per Unit
                </TableCell>
                {showAdvanced && (
                  <TableCell align='right' sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                    Unit Discount
                  </TableCell>
                )}
                <TableCell sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                  Quantity
                </TableCell>
                {showAdvanced && (
                  <TableCell align='right' sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                    Avg Unit Price
                  </TableCell>
                )}
                <TableCell align='right' sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                  Total
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell align='right'>{item?.price} kr.</TableCell>
                {showAdvanced && (
                  <TableCell align='right'>{productDiscountAverage()}%</TableCell>
                )}
                <TableCell>x {itemCounter}</TableCell>
                {showAdvanced && (
                  <TableCell align='right'>{productPriceAverage()} kr.</TableCell>
                )}
                <TableCell align='right'>{productTotal()} kr.</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* ADD-ONS TABLE */}
      {extraDisplay?.extras?.length > 0 && (
        <Box mt={3}>
          <Typography variant='subtitle2' gutterBottom>
            Add-Ons
          </Typography>
          <TableContainer>
            <Table size='small'>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>Add-On</TableCell>
                  <TableCell align='right' sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                    Price per Unit
                  </TableCell>
                  {showAdvanced && (
                    <>
                      <TableCell align='right' sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                        Unit Discount
                      </TableCell>
                      <TableCell sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                        Quantity
                      </TableCell>
                      <TableCell align='right' sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                        Avg Unit Price
                      </TableCell>
                    </>
                  )}
                  <TableCell align='right' sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                    Total
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {extraDisplay.extras.map((extraItem, i) => (
                  <TableRow key={i}>
                    <TableCell>{extraItem.item}</TableCell>
                    <TableCell align='right'>{extraItem.price} kr.</TableCell>
                    {showAdvanced && (
                      <>
                        <TableCell align='right'>{extraDiscountAverage(i)}%</TableCell>
                        <TableCell>x {extraItem.quantity}</TableCell>
                        <TableCell align='right'>{extraPriceAverage(i)} kr.</TableCell>
                      </>
                    )}
                    <TableCell align='right'>{extraItemTotal(i)} kr.</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}

      {/* PRICE SUMMARY */}
      <Box mt={3}>
        <Typography variant='subtitle2' gutterBottom>
          Price Summary
        </Typography>
        <TableContainer>
          <Table size='small'>
            <TableBody>
              <TableRow>
                <TableCell>Delivery</TableCell>
                <TableCell align='right'>{delivery()} kr.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Bonus Discount</TableCell>
                <TableCell align='right'>-{bonusDiscountFunc()} kr.</TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>Grand Total</TableCell>
                <TableCell align='right' sx={{ fontWeight: "bold", color: CROMBO_ORANGE }}>
                  {grandTotal()} kr.
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default SummaryTable;
